module.exports = __webpack_public_path__ + "img/testcricket.91a84651.svg";